import * as microsoftTeams from "@microsoft/teams-js";
import { createDataLayerClient, IDataLayerClient } from "@msteams/core-cdl-sdk";

let CDLClient: IDataLayerClient = null;
let CDLClientPromise: Promise<IDataLayerClient> | null = null;

export const getCDLClient = async () => {
    if (CDLClient) {
        return CDLClient;
    }
    // Guard against concurrent first-time initialization: without sharing a single in-flight
    // promise, callers that mount together (e.g. one per team in a list) would each run
    // createCDLClient() in parallel, racing on getDataLayerPort() so all but one fail.
    if (!CDLClientPromise) {
        CDLClientPromise = createCDLClient()
            .then((client) => {
                CDLClient = client;
                return client;
            })
            .catch((error) => {
                CDLClientPromise = null;
                throw error;
            });
    }
    return CDLClientPromise;
};

const createCDLClient = async () => {
    try {
        await microsoftTeams.app.initialize();
        await microsoftTeams.app.notifySuccess();

        const port = await microsoftTeams.messageChannels.dataLayer.getDataLayerPort();
        const dataLayerResponse = createDataLayerClient(port);
        await dataLayerResponse.initialize();
        return dataLayerResponse.dataLayerClient;
    } catch (error) {
        throw new Error(`Failed to initialize CDL Client - ${error}`);
    }
};
